import IconBox from "../../../../iconboxes/IconBox";
import { frontendOptions } from "../../../../../lib/systemData";

export default function LiabilityDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    const liabilities = Array.isArray(row.liabilities) ? row.liabilities : []
    const primaryLiability = liabilities.find((l) => l.is_primary_insurance) || null
    const liabilitiesCount = row.liabilities_count ?? liabilities.length

    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>Liability</h3>
            {liabilitiesCount >= 2 && <div className={classes.totals}>{liabilitiesCount}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 1)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        <div className={classes.block_body}>
            
            <div className={classes.block_body_row}>
                <div className={classes.label}>Carrier</div>
                <div className={classes.value}>{primaryLiability?.insurance_carrier?.name}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Status</div>
                <div className={classes.value}>
                    {frontendOptions()?.assumedOptions?.find(item => item.value == primaryLiability?.liability_status)?.label}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Adjuster</div>
                <div className={classes.value}>
                    {primaryLiability?.adjuster && <>
                        <div>{primaryLiability.adjuster.first_name} {primaryLiability.adjuster.last_name}</div>
                        {primaryLiability.adjuster.contact_information && primaryLiability.adjuster.contact_information.phone && <IconBox type={'phone'} link={primaryLiability.adjuster.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Claim Number</div>
                <div className={classes.value}>{primaryLiability?.claim_number}</div>
            </div>
            
            <div className={classes.block_body_row}>
                <div className={classes.label}>Liability Paid At</div>
                <div className={classes.value}>{primaryLiability?.liability_paid_at ? primaryLiability?.liability_paid_at +'%' : ''}</div>
            </div>
        </div>
    </div>
}